export class RoleEdit {
  email?: string;
  userId?: number;
  roleId?: number;
  organiserId? : number;

  constructor(email?: string, userId?: number, roleId?: number, organiserId?: number) {
    this.email = email;
    this.userId = userId;
    this.roleId = roleId;
    this.organiserId = organiserId;
  }
}
